import React from 'react';

const CodeScreen = ({ className = '' }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width="75"
      height="75"
      x="0"
      y="0"
      viewBox="0 0 74 74"
    >
      <circle r="37" cx="37" cy="37" fill="#eae9f8" shape="circle" />
      <g transform="matrix(0.08,0,0,0.080,18,18)">
        <g xmlns="http://www.w3.org/2000/svg">
          <path
            d="m167.313,209.123c-2.12-3.559-6.723-4.726-10.281-2.605l-87.369,52.039c-2.271,1.352-3.663,3.8-3.663,6.443s1.392,5.091 3.662,6.443l87.369,52.039c1.203,0.717 2.525,1.058 3.831,1.058 2.556,0 5.048-1.308 6.45-3.663 2.12-3.559 0.953-8.162-2.605-10.281l-76.551-45.596 76.551-45.596c3.559-2.119 4.726-6.722 2.606-10.281z"
            fill="#5c48d3"
          />
          <path
            d="m302.688,320.877c1.403,2.356 3.894,3.663 6.45,3.663 1.306,0 2.628-0.341 3.831-1.058l87.369-52.039c2.271-1.353 3.662-3.8 3.662-6.443s-1.392-5.091-3.662-6.443l-87.369-52.039c-3.558-2.12-8.163-0.954-10.281,2.605-2.12,3.559-0.953,8.162 2.605,10.281l76.551,45.596-76.551,45.596c-3.559,2.119-4.726,6.722-2.605,10.281z"
            fill="#5c48d3"
          />
          <path
            d="m263.72,208.78l-69.893,104.078c-2.309,3.438-1.394,8.098 2.045,10.408 1.284,0.862 2.737,1.274 4.175,1.274 2.415,0 4.786-1.165 6.233-3.32l69.893-104.078c2.309-3.438 1.394-8.098-2.045-10.408-3.441-2.309-8.1-1.392-10.408,2.046z"
            fill="#5c48d3"
          />
          <path
            d="m462.5,22.5h-455c-4.143,0-7.5,3.358-7.5,7.5v410c0,4.142 3.357,7.5 7.5,7.5h455c4.143,0 7.5-3.358 7.5-7.5v-80c0-4.142-3.357-7.5-7.5-7.5s-7.5,3.358-7.5,7.5v72.5h-440v-335h440v232.5c0,4.142 3.357,7.5 7.5,7.5s7.5-3.358 7.5-7.5v-300c0-4.142-3.357-7.5-7.5-7.5zm-447.5,15h277.5v45h-277.5v-45zm292.5,45v-45h147.5v45h-147.5z"
            fill="#5c48d3"
          />
          <path
            d="m381.5,52c-4.411,0-8,3.589-8,8s3.589,8 8,8 8-3.589 8-8-3.589-8-8-8z"
            fill="#5c48d3"
          />
          <path
            d="m340.5,52c-4.411,0-8,3.589-8,8s3.589,8 8,8 8-3.589 8-8-3.589-8-8-8z"
            fill="#5c48d3"
          />
          <path
            d="m422.5,52c-4.411,0-8,3.589-8,8s3.589,8 8,8 8-3.589 8-8-3.589-8-8-8z"
            fill="#5c48d3"
          />
        </g>
      </g>
    </svg>
    // <svg
    //   className={className}
    //   xmlns="http://www.w3.org/2000/svg"
    //   width="75"
    //   height="75"
    //   x="0"
    //   y="0"
    //   viewBox="0 0 74 74"
    // >
    //   <circle r="37" cx="37" cy="37" fill="#eae9f8" shape="circle" />
    //   <g transform="matrix(0.68,0,0,0.68,11.84,11.839359741210924)">
    //     <path
    //       xmlns="http://www.w3.org/2000/svg"
    //       d="M17.965,44.271a.95.95,0,0,1-.2-.02,1,1,0,0,1-.784-1.177l3.2-15.894a1,1,0,0,1,.98-.8H52.844a1,1,0,0,1,.98.8l3.2,15.884a1,1,0,0,1-1.961.395L52.025,28.377H21.984l-3.04,15.091A1,1,0,0,1,17.965,44.271Z"
    //       fill="#5c48d3"
    //     />
    //     <path
    //       xmlns="http://www.w3.org/2000/svg"
    //       d="M28.619,63.028H14.182a1,1,0,0,1-.981-1.2l2.365-11.713a1,1,0,0,1,1.961.4L15.4,61.028H28.619a1,1,0,0,1,0,2Z"
    //       fill="#5c48d3"
    //     />
    //     <path
    //       xmlns="http://www.w3.org/2000/svg"
    //       d="M59.828,63.028H45.381a1,1,0,0,1,0-2H58.606L56.482,50.513a1,1,0,0,1,1.961-.4L60.809,61.83a1,1,0,0,1-.981,1.2Z"
    //       fill="#5c48d3"
    //     />
    //     <path
    //       xmlns="http://www.w3.org/2000/svg"
    //       d="M46.548,28.377a1,1,0,0,1-1-1v-.359a5.257,5.257,0,0,0-5.255-5.246H33.707a5.257,5.257,0,0,0-5.255,5.246v.359a1,1,0,0,1-2,0v-.359a7.259,7.259,0,0,1,7.255-7.246h6.586a7.259,7.259,0,0,1,7.255,7.246v.359A1,1,0,0,1,46.548,28.377Z"
    //       fill="#5c48d3"
    //     />
    //     <path
    //       xmlns="http://www.w3.org/2000/svg"
    //       d="M37,18a5.656,5.656,0,1,1,5.656-5.656A5.662,5.662,0,0,1,37,18Zm0-9.312a3.656,3.656,0,1,0,3.656,3.656A3.66,3.66,0,0,0,37,8.692Z"
    //       fill="#5c48d3"
    //     />
    //     <path
    //       xmlns="http://www.w3.org/2000/svg"
    //       d="M20.467,51.318H3a1,1,0,0,1-1-1V48a6.728,6.728,0,0,1,6.72-6.72h6.027A6.728,6.728,0,0,1,21.467,48v2.321A1,1,0,0,1,20.467,51.318ZM4,49.318H19.467V48a4.725,4.725,0,0,0-4.72-4.72H8.72A4.725,4.725,0,0,0,4,48Z"
    //       fill="#5c48d3"
    //     />
    //     <path
    //       xmlns="http://www.w3.org/2000/svg"
    //       d="M11.733,39.829a5.261,5.261,0,1,1,5.261-5.261A5.267,5.267,0,0,1,11.733,39.829Zm0-8.522a3.261,3.261,0,1,0,3.261,3.261A3.265,3.265,0,0,0,11.733,31.307Z"
    //       fill="#5c48d3"
    //     />
    //     <path
    //       xmlns="http://www.w3.org/2000/svg"
    //       d="M71,51.318H53.533a1,1,0,0,1-1-1V48a6.728,6.728,0,0,1,6.72-6.72H65.28A6.728,6.728,0,0,1,72,48v2.321A1,1,0,0,1,71,51.318Zm-16.467-2H70V48a4.725,4.725,0,0,0-4.72-4.72H59.253A4.725,4.725,0,0,0,54.533,48Z"
    //       fill="#5c48d3"
    //     />
    //     <path
    //       xmlns="http://www.w3.org/2000/svg"
    //       d="M62.267,39.829a5.261,5.261,0,1,1,5.26-5.261A5.267,5.267,0,0,1,62.267,39.829Zm0-8.522a3.261,3.261,0,1,0,3.26,3.261A3.265,3.265,0,0,0,62.267,31.307Z"
    //       fill="#5c48d3"
    //     />
    //     <path
    //       xmlns="http://www.w3.org/2000/svg"
    //       d="M45.733,67.308H28.267a1,1,0,0,1-1-1V63.987a6.726,6.726,0,0,1,6.719-6.719h6.028a6.726,6.726,0,0,1,6.719,6.719v2.321A1,1,0,0,1,45.733,67.308Zm-16.466-2H44.733V63.987a4.724,4.724,0,0,0-4.719-4.719H33.986a4.724,4.724,0,0,0-4.719,4.719Z"
    //       fill="#5c48d3"
    //     />
    //     <path
    //       xmlns="http://www.w3.org/2000/svg"
    //       d="M37,55.819a5.261,5.261,0,1,1,5.261-5.261A5.268,5.268,0,0,1,37,55.819ZM37,47.3a3.261,3.261,0,1,0,3.261,3.261A3.265,3.265,0,0,0,37,47.3Z"
    //       fill="#5c48d3"
    //     />
    //   </g>
    // </svg>
  );
};
export default CodeScreen;
